import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { ClienteFechamentoInterface } from "app/module/cliente-fechamento-interface";

@Injectable({
	providedIn: 'root'
})
export class ClienteFechamentoService {
	private url: string = environment.g2e_api;

	private httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json; charset=UTF-8',
			'Authorization': 'Bearer ' + localStorage.getItem("tokenApiG2E")
		}),
	}

	private httpOptionsNoAuth = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json; charset=UTF-8',
			// 'Authorization': 'Bearer ' + localStorage.getItem("tokenApiG2E")
		}),
	}

	constructor(private http: HttpClient) { }

	public findAll(): Observable<ClienteFechamentoInterface[]> {
		return this.http.get<ClienteFechamentoInterface[]>(`${this.url}cliente-fechamento`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public findOne(token: number): Observable<ClienteFechamentoInterface[]> | undefined {
		return this.http.get<ClienteFechamentoInterface[]>(`${this.url}cliente-fechamento/token/${token}`, this.httpOptionsNoAuth).pipe(
			(res) => res,
			(error) => error
		);
	}

	public create(data: ClienteFechamentoInterface): Observable<ClienteFechamentoInterface> {
		return this.http
			.post<any>(`${this.url}cliente-fechamento/create`, data, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public update(data: ClienteFechamentoInterface): Observable<ClienteFechamentoInterface> {
		return this.http.put<any>(`${this.url}cliente-fechamento/${data.id_cliente_fechamento}`, data, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	// public remove(data: number, id: number): Observable<any> {
	// 	return this.http
	// 		.put<any>(`${this.url}sistema/${id}/update`, {
	// 			id_sistema: id,
	// 			isDeleted: data,
	// 		})
	// 		.pipe(
	// 			(res) => res,
	// 			(error) => error
	// 		);
	// }
}
